/** Client fallback when API omits release_year (matches backend heuristics). */
export function inferReleaseYear(brand?: string | null, model?: string | null): number | null {
  const text = `${brand ?? ''} ${model ?? ''}`.trim().toLowerCase()
  if (!text) return null

  const iphone = text.match(/iphone\s*(?:se\s*)?(\d{1,2})\b/)
  if (iphone) {
    const n = parseInt(iphone[1], 10)
    const map: Record<number, number> = {
      5: 2012,
      6: 2014,
      7: 2016,
      8: 2017,
      9: 2018,
      10: 2018,
      11: 2019,
      12: 2020,
      13: 2021,
      14: 2022,
      15: 2023,
      16: 2024,
      17: 2025,
    }
    return map[n] ?? null
  }

  const galaxy = text.match(/galaxy\s*s\s*(\d{1,2})\b/)
  if (galaxy) {
    const n = parseInt(galaxy[1], 10)
    if (n >= 20) return 2000 + n
    if (n >= 8) return 2009 + n
  }

  return null
}
